export default "__VITE_ASSET__yXioPBW1__"